<template>
	<section>
		<div class="d-flex flex-row align-items-center justify-content-between">
			<h3 class="mb-0">Labour</h3>

			<div v-if="!isFinalized">
				<button class="btn btn-success" v-on:click="newLabour">
					<i class="fa fa-plus"></i>
					Add Labour Line
				</button>

				<button v-if="!hideRegenButton" class="btn btn-light" title="Regenerate Labour" v-on:click="confirmRegen">
					<i class="fa fa-sync"></i>
				</button>
			</div>
		</div>

		<table-list
			record-name="Labour Record"
			:fields="labourFields"
			:records="mutatedLabour"
			:has-edit="!isFinalized"
			:has-delete="!isFinalized"
			:hide-record-count="true"
			v-on:edit="editLabour"
			v-on:delete="deleteObject($event,'ServiceInvoiceObject')">

		</table-list>

		<modal-dialog
			:modal-visible="labourEditModal.visible"
			:title="labourEditModal.title"
			confirm-button-text="Save"
			v-on:confirm="saveObject(labourEditModal)"
			v-on:closeModal="labourEditModal.visible = false">

			<form-group
				label="Labour Type" 
				col-class="col-md-4">

				<div class="d-flex align-items-center">
					<field style='flex-grow: 1'
						:params="{type: showChargeOutGroupOptions ? 'select' : 'text', options: chargeOutGroupOptions}"
						v-on:change="typeChange"
						v-model="labourEditModal.payload.chargeOutGroupName">
					</field>
					<div :style="{marginTop: showChargeOutGroupOptions ? '-2px' : 0}">
						<button type="button" 
							class="btn btn-light btn-attached"
							:title="showChargeOutGroupOptions ? 'Switch to free-form' : 'Switch to Chargeout Group selections'" 
							v-on:click="showChargeOutGroupOptions = !showChargeOutGroupOptions">
							<template v-if="!showChargeOutGroupOptions">
								<i class="fa fa-caret-down"></i>
							</template>
							<template v-else>
								<i class="fa fa-pencil-alt"></i>
							</template>
						</button>
					</div>
				</div> 

				<div class="text-muted">Labour type can be edited as desired</div>
				
			</form-group>

			<field label="Hrs" 
				col-class="col-md-4" 
				:params="{type:'number',min:0,step:0.25}" 
				v-model="labourEditModal.payload.hrs">
			</field>

			<field label="Rate" 
				col-class="col-md-4" 
				:params="{type:'number',min:0,step:0.01}" 
				v-model="labourEditModal.payload.rate">
			</field>

		</modal-dialog>

	</section>
</template>
<script type="text/javascript">
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import InfoBox from "@/components/InfoBox"
import FormGroup from "@/components/FormGroup"

import InvoiceMixins from "@/mixins/InvoiceMixins.js"
import ServiceMixins from "@/mixins/ServiceMixins.js"

export default {
	name: "InvoiceLabourSection",
	components: {
		TableList,
		ModalDialog,
		Field,
		InfoBox,
		FormGroup
	},
	props: ["invoiceLabour","invoiceId","hideRegenButton","materialLabourTotal","isFinalized","clientRateOverrides"],
	mixins: [InvoiceMixins,ServiceMixins],
	data() {
		return {
			labourFields: [
				{label: "Labour Type", key: "chargeOutGroupName"},
				{label: "Hrs",key:"hrs",align:"right"},
				{label: "Rate",key:"rate",align:"right"},
				{label: "Total",key:"total",align:"right"}
			],
			labourEditModal: {
				visible: false,
				title: "Edit Labour Line",
				payload: {},
				lineTotal: 0
			},
			chargeOutGroups: [],
			showChargeOutGroupOptions: false
		}
	},
	computed: {
		chargeOutGroupOptions() {
			return this.chargeOutGroups.map(group => group.label)
		},
		mutatedLabour() {
			let vm = this

			return this.invoiceLabour.map(item => {
				item.hrs = parseFloat(item.hrs).toFixed(2)
				item.rate = parseFloat(item.rate).toFixed(2)

				let total = parseFloat(item.hrs) * parseFloat(item.rate)
				item.total = total.toFixed(2)

				return item
			})
		},
	},
	methods: {
		newLabour() {
			
			this.labourEditModal.title = "Add Labour Line to Invoice"
			this.labourEditModal.payload = {
				invoice_id: this.invoiceId,
				type: "Labour",
				hrs: 0,
				rate: 0,
				chargeOutGroupName: ""
			}
			this.labourEditModal.visible = true
		},
		editLabour(record) {
			this.labourEditModal.visible = true
			this.labourEditModal.title = "Edit Labour Line"
			this.labourEditModal.payload = JSON.parse(JSON.stringify(record))
		},
		typeChange(value) {
			let group = this.chargeOutGroups.find(gr => gr.label == value)

			console.log(this.chargeOutGroups)

			//check if there is a customer level override
			if (group) {

				console.log(group)

				let overrideGroup = this.clientRateOverrides.find(overrideGroup => overrideGroup.group_id == group.id)

				console.log(overrideGroup)

				if (overrideGroup && "newRateRegular" in overrideGroup && overrideGroup.newRateRegular) 
					this.labourEditModal.payload.rate = overrideGroup.newRateRegular
				else
					this.labourEditModal.payload.rate = group.charge_out_rate
				
				this.showChargeOutGroupOptions = false
			}
		},
		fetchChargeoutGroups() {
			let vm = this

			this.getJSON("ClassificationGroup/get").then(response => {
				if (response.success) {
					vm.chargeOutGroups = response.data
				}
			})
		}
	},
	created() {
		this.fetchChargeoutGroups()
	}
}
</script>